import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SchoolCampaignsPage = lazy(() => import('../pages/school-campaigns/page'));
const BusinessEventsPage = lazy(() => import('../pages/business-events/page'));
const CreateDesignPage = lazy(() => import('../pages/create-design/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const PromotionalProductsPage = lazy(() => import('../pages/promotional-products/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/school-campaigns',
    element: <SchoolCampaignsPage />
  },
  {
    path: '/business-events',
    element: <BusinessEventsPage />
  },
  {
    path: '/create-design',
    element: <CreateDesignPage />
  },
  {
    path: '/catalog',
    element: <CatalogPage />
  },
  {
    path: '/promotional-products',
    element: <PromotionalProductsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
